import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

import { getBundle, getItem } from '../../utils/helpers'
import { Tag, Modal, Button } from 'antd'
import { CheckOutlined, TrophyOutlined } from '@ant-design/icons'

const imgs = require.context('../../assets/img', true)

const Seasons = ({ seasons }) => {
  return seasons ? (
    <>
      {seasons.map((s) => (
        <Tag key={s} style={{ cursor: 'pointer' }}>
          {s}
        </Tag>
      ))}
    </>
  ) : (
    <Tag style={{ cursor: 'pointer' }}>Any</Tag>
  )
}

Seasons.propTypes = {
  seasons: PropTypes.array,
}

const Items = ({
  bundle,
  bundleCompleted,
  bundleStatus,
  handleItemClick,
  size,
}) => {
  const items = bundle.items
  const quantities = bundle.quantities || []
  return (
    <table className="bundle-table">
      <tbody>
        {items.map((itemId, i) => {
          if (!!size && i >= size) return undefined
          const item = getItem(itemId)
          const itemCompleted = bundleStatus[itemId]
          const tdClass =
            itemCompleted && !bundleCompleted
              ? 'bundle-table-data-completed'
              : 'bundle-table-data'

          return (
            <tr
              key={itemId}
              onClick={() => handleItemClick(itemId)}
              className={i > 0 ? 'bundle-table-row' : 'bundle-table-row-first'}>
              <td className={tdClass}>
                <img src={imgs('./' + item.img)} alt="N/A"></img>
              </td>
              <td className={tdClass}>
                <a
                  href={item.url}
                  onClick={(e) => e.stopPropagation()}
                  target="__blank">
                  {`${item.name} ${!quantities[i] ? '' : `(${quantities[i]})`}`}
                </a>
              </td>
              <td className={tdClass}>
                <Seasons seasons={item.seasons} />
              </td>
              <MediaQuery minDeviceWidth={525}>
                <td className={tdClass}>{item.description}</td>
              </MediaQuery>
              {!bundleCompleted && itemCompleted ? (
                <td style={{ width: '20px' }}>
                  <CheckOutlined />
                </td>
              ) : (
                <td style={{ width: '20px' }} />
              )}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

Items.propTypes = {
  bundle: PropTypes.object,
  bundleCompleted: PropTypes.bool,
  bundleStatus: PropTypes.object,
  handleItemClick: PropTypes.func,
  size: PropTypes.number,
}

const Bundle = ({
  bundleId,
  bundleStatus,
  completeItem,
  uncompleteItem,
  style,
}) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [resetVisible, setResetVisible] = useState(false)
  const [bundleCompleted, setBundleCompleted] = useState(false)
  const bundle = getBundle(bundleId)
  const reward = getItem(bundle.reward?.item)
  const rewardQuanity = bundle.reward?.quantity

  useEffect(() => {
    const bundleCompleted =
      Object.values(bundleStatus).reduce((total, status) => {
        return total + (status ? 1 : 0)
      }, 0) === bundle.required

    setBundleCompleted(bundleCompleted)
    if (bundleCompleted) setModalVisible(false)
  }, [bundle.required, bundleStatus])

  const handleItemClick = (itemId) => {
    if (bundleStatus[itemId]) {
      uncompleteItem(bundleId, itemId)
    } else {
      completeItem(bundleId, itemId)
      setResetVisible(true)
    }
  }

  const resetBundle = () => {
    bundle.items.forEach((itemId) => {
      uncompleteItem(bundleId, itemId)
    })
  }

  return (
    <div>
      <div
        className={bundleCompleted ? 'bundle-completed' : 'bundle'}
        style={style}>
        <div className="bundle-header">
          <h3>{bundle.name}</h3>
          {bundle.reward && (
            <div>
              <TrophyOutlined style={{ fontSize: '18px' }} />
              <a href={reward.url} target="__blank">
                <MediaQuery minDeviceWidth={450}>
                  <span>{reward.name}</span>
                </MediaQuery>
                <img src={imgs('./' + reward.img)} alt="N/A" />
                <span>{`(${rewardQuanity})`}</span>
              </a>
            </div>
          )}
        </div>
        {bundle.type === 'vault' ? (
          <div
            className="bundle-purchase"
            onClick={() => handleItemClick(bundle.items[0])}>
            <img
              src={imgs('./Bundle_Purchase.png')}
              style={{ height: '50px' }}
              alt="N/A"
            />
            <div>
              <img
                src={imgs('./Gold.png')}
                style={{ width: '30px' }}
                alt="N/A"
              />
              <span>{bundle.name}</span>
            </div>
          </div>
        ) : (
          <Items
            {...{ bundle, bundleCompleted, bundleStatus, handleItemClick }}
            size={4}
          />
        )}
        {bundle.items.length > 4 && (
          <div style={{ textAlign: 'center' }}>
            <div className="more-button" onClick={() => setModalVisible(true)}>
              More...
            </div>
          </div>
        )}
        <Modal
          title={bundle.name + ' Bundle (' + bundle.required + ' required)'}
          visible={modalVisible}
          footer={null}
          onCancel={() => setModalVisible(false)}>
          <Items {...{ bundle, bundleStatus, handleItemClick }} />
        </Modal>
      </div>
      {bundleCompleted && (
        <div
          className="bundle-completed-overlay"
          onMouseOver={() => setResetVisible(true)}
          onMouseLeave={() => setResetVisible(false)}
          onClick={() => setResetVisible(!resetVisible)}>
          <CheckOutlined style={{ fontSize: 40 }} />
          <h3>Completed</h3>
          {resetVisible && (
            <Button
              type="primary"
              ghost={true}
              onClick={resetBundle}
              onTouchEnd={(e) => {
                e.preventDefault()
                resetBundle()
              }}
              onTouchStart={(e) => e.preventDefault()}
              style={{ marginTop: '30px', width: '100px' }}>
              Reset
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

Bundle.propTypes = {
  bundleId: PropTypes.string,
  bundleStatus: PropTypes.object,
  completeItem: PropTypes.func,
  uncompleteItem: PropTypes.func,
  style: PropTypes.any,
}

export default Bundle
